import React from 'react';
import classNames from 'classnames';
import PdfNoEmbedBase from './pdf_no_embed_base.jsx';

const PdfNoEmbedDesktop = (props)=>
  <PdfNoEmbedBase {...props} 
    className={classNames('pdf-section-desktop-wrapper')} 
  />;

export default PdfNoEmbedDesktop;